<script lang="ts">
export let name: string | undefined;
export let checked = false;
export let disabled = false;
export let required = false;

function handleChecked(evt: Event) {
    checked = (evt.target as HTMLInputElement).checked;
}
</script>
<div class="checkbox">
    <label>
        <input type="checkbox" {checked} {name} {required} {disabled} on:change={handleChecked}/>
        <slot></slot>
    </label>
</div>
